import { Icon, type IconName } from './Icon';

type EmptyStateProps = {
  icon?: IconName;
  title: string;
  subtitle?: string;
};

export function EmptyState({ icon = 'inbox', title, subtitle }: EmptyStateProps) {
  return (
    <div className="empty">
      <div className="ei">
        <Icon name={icon} />
      </div>
      <div className="et">{title}</div>
      {subtitle && <div className="es">{subtitle}</div>}
    </div>
  );
}
